export class PunchRepository {
    private httpService: IHttpService
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    /**
     * Ejemplo punch
     *   {
     *       "punch_dtm": "2024-05-17T12:30:00",
     *       "employee_id": 6,
     *       "device_id": -1,
     *       "in_out": false,
     *       "type_autentification": "finger",
     *       "timezone": "America/Santiago",
     *       "online": true
     *   }
     * @param punch
     * @returns
     */
    async createPunch(punch: { punch_dtm: string; employee_id: number; device_id: number; in_out: boolean; type_autentification: string; timezone: string; online: boolean; }): Promise<any> {
        try {
            const response = await this.httpService.post<any, any>('/punches/create_punch', { data: punch });
            return response.data;
        } catch (error) {
            console.error('Error al crear el punch:', error);
            throw error;
        }
    }

    /**
     * @param punch
     * @returns
     */
    async disablePunch(punch_ids: {ids: number[]}): Promise<any> {
        try {
            const response = await this.httpService.post<any, any>(`/punches/disable`, { data: punch_ids });
            return response.data;
        } catch (error) {
            console.error('Error al deshabilitar el punch:', error);
            throw error;
        }
    }
}